import { Outlet, createRootRoute } from "@tanstack/react-router";
import { useT } from "../lib/i18n";

function NotFound() {
  const { t } = useT();
  return (
    <main className="mx-auto min-h-dvh w-full max-w-md px-4 py-6 text-center">
      <h1 className="font-serif text-2xl text-ink">{t("common.not_found")}</h1>
    </main>
  );
}

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFound,
});
